import { client } from "../client";
import { Supply } from "../types/supplies.types";
import { createFile } from "./file.mutations";

export const orderSupplies = async ({ order }: { order: { quantity: number, supplyId: number }[] }) => {
  const response = await client.post<object>(`supplies/order`, {
    order
  });
  return response.data;
};

export const createSupply = async ({ files, ...props }: Partial<Supply> & { files: FileList }) => {
  // 1. Upload files
  let file = null;
  if (files.length > 0) {
    file = await createFile({ file: files[0], fileName: undefined })
  }
  // 2. Create ticket
  const response = await client.post<Supply>(`supplies/`, {
    ...props,
    fileId: file ? file.id : null
  })
  return response.data
}

export const updateSupply = async ({ files, ...props }: Partial<Supply> & { files: FileList }) => {
  // 1. Upload files
  let file = null;
  if (files.length > 0) {
    file = await createFile({ file: files[0], fileName: undefined })
  }
  // 2. Create ticket
  const response = await client.patch<Supply>(`supplies/${props.id}/`, {
    ...props,
    fileId: file ? file.id : null
  })
  return response.data
}

export const deleteSupply = async ({ id }: { id: number }) => {
  const response = await client.delete(`supplies/${id}/`)
  return response.data
}